export function emailAdviceRejecteddHTML(
  fromName,
  fromEmail,
  reloadYard,
  outbound
) {
  let appointmentDetails = "";
  let pickupNumber = "";

  if (outbound.scheduledDateTime) {
    const formattedDate = new Date(
      outbound.scheduledDateTime
    ).toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
    appointmentDetails += `<strong>Appointment Date and Time:</strong> ${formattedDate}<br>`;
  }

  if (outbound.pickupNumber) {
    pickupNumber += `<strong>Pickup Number:</strong> ${outbound.pickupNumber}<br>`;
  }

  return `<!-- Begin HTML Content -->
        <h2> Your Outbound Shipment request was rejected.<br></h2>
        <hr style="background:#2d8cff; height: 8px; width: 60px; border-style: solid; border-color: #095484; border-width: 1px 0 0 0; border-radius: 8px;" />
        <br><br>
        Here are the details:
        <br><br>
        ${pickupNumber}
        ${appointmentDetails}
        <strong>Facility:</strong> ${reloadYard.name}<br>
        <strong>Address:</strong> ${reloadYard.street}<br>
        ${reloadYard.city}, ${reloadYard.state} ${reloadYard.zipCode}
        <br><br>
        Please review your outbound request and inspect NOTES tab for additional information.
        <br><br><br>
        <table bgcolor="#FF5F0F" style="border-radius:3px; border-spacing:0; margin:0 auto">
            <tbody>
                <tr style="background:#FF5F0F;">
                    <td class="mobile-cta" style="border: 0 solid #FF5F0F;  display: inline-block; padding: 20px 45px; text-align: center; font-family:'Lato', Helvetica, sans-serif; font-size:15px; line-height:24px; color:#FFFFFF; font-weight:900; text-decoration: none; text-transform: uppercase; letter-spacing: .2em">
                        <a href="https://app.transloads.co/outboundShipments/${outbound.id}/show"
                            target="_blank"
                            rel="noreferrer"
                            style="color:#FFFFFF; text-decoration:none;"
                        >
                            VIEW OUTBOUND
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <br><br>
        <hr style="border-bottom:#CCCCCC 6px dotted; border-width: 0 0 6px 0;">
        <br>
        If you have any questions, please contact ${fromName} at ${fromEmail}.
        <!-- End HTML Content -->`;
}
